import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone } from '@/components/DeskeyIcons';

const APP_NAMES = {
  teacher: 'Deskey Teacher',
  student: 'Deskey Student',
};

/** "Get the app" row under the teacher / student login form. Kept quiet so
 * the Sign in button stays the only filled action on the page. */
export default function MobileAppPromo({ role }) {
  const appName = APP_NAMES[role];
  if (!appName) return null;

  return (
    <div className="mt-8 flex items-center gap-3 rounded-xl border border-gray-200 px-4 py-3" data-testid={`mobile-app-promo-${role}`}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-gray-100 text-gray-600">
        <Smartphone className="w-4 h-4" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900">{appName} app</p>
        <p className="text-xs text-gray-600">Available for Android</p>
      </div>
      <Link to={`/get-app/${role}`} className="shrink-0 rounded-md px-2 py-1 text-sm font-medium text-gray-900 underline-offset-4 hover:underline" data-testid="mobile-app-download">
        Download
      </Link>
    </div>
  );
}
